import DrawerItem from '@/lib/drawer/DrawerItem'
let defaultOpts = {
  disabled: true,
  dense: true,
  color: 'amber darken-1',
  dark: true,
  prominent: false,
  title: null,
  fixed: false,
  backTo: null,

  sideBtns: [], // 右上角的按鈕
  options: [] // 右上角的選單打開後，要出現的選項
}
/**
 * @type {import('vuex').Module}
 */
export const appbar = {
  namespaced: true,
  state: {
    // 是否取消通用的appbar功能
    disabled: true,

    // drawer: false, // 是否顯示 drawer
    // drawer.toggleBtn: false, // 是否顯示 drawer 的按鈕
    // drawer.items: [],
    // drawerStateless: false,
    drawer: {
      show: false,
      toggleBtn: false, // 是否顯示 drawer 的按鈕
      items: [],
      autoDisplay: false
    },
    ...defaultOpts
  },
  mutations: {
    toggle(state, enable){
      if(typeof enable === 'undefined'){
        state.disabled = !state.disabled
      }else{
        state.disabled = !enable
      }
      this.commit('updateTopMargin', null, { root: true })
    },
    setupDrawer(state, options, rootState){
      // items 的類型為 @/lib/drawer/DrawerItem
      let { items, currentPage, show, autoDisplay } = options
      if(items){
        state.drawer.toggleBtn = true
        state.drawer.items = items.map((item)=>new DrawerItem(item))
      }
      state.drawer.show = !!show
      state.drawer.autoDisplay = !!autoDisplay
      if(currentPage){
        rootState.currentPage = currentPage
      }
    },
    // 單純禁用但不清空 items
    disableDrawer(state){
      state.drawer.show = false
      state.drawer.toggleBtn = false
    },
    // 禁用且清空 items
    clearDraer(state){
      state.drawer.show = false
      state.drawer.toggleBtn = false
      state.drawer.items = []
      state.drawer.autoDisplay = false
    },
    toggleDrawer(state, open){
      if(typeof open === 'undefined'){
        // console.log('toggleDrawer toggle', !state.drawer.show)
        state.drawer.show = !state.drawer.show
      }else{
        // console.log('toggleDrawer', open)
        state.drawer.show = open
      }
    },
    // 若要禁止該功能 請將 to 設置為$disable
    // 實際使用在 AppBar.vue 可以找到
    backTo(state, to){
      if(to){
        state.backTo = to
      }else{
        state.backTo = null
      }
    },
    // 復原所有 appbar 的狀態
    recovery(state){
      Object.assign(state, defaultOpts)
    },
    /**
     * @typedef {Object} AppbarOptions
     * @property {string} text 選項顯示的文字
     * @property {string} key 識別選項用的 key
     */
    /**
     * @param {*} state
     * @param {AppbarOptions[]} options
     */
    setOptions(state, options){
      if(options){
        state.options = options
        console.log('update appbar options')
      }else{
        state.options = []
      }
    },
    /**
     * @typedef {Object} UpdateAppbarOptionsParam
     * @property {string} key *識別選項用的 key
     * @property {?string} delete 若該選項為 true 則把該對應的 option 刪除
     * @property {?Object} update 若有該屬性，則會將該屬性中所有的部分覆蓋至對應的 option
     */
    /**
    * @param {*} state
    * @param {UpdateAppbarOptionsParam} param
    */
    updateOption(state, param){
      if(!param.key)return
      let index = state.options.findIndex((opt)=>opt.key === param.key)
      if(index < 0){
        console.warn(`option(${param.key}) not found`)
        return
      }
      if(param.delete){
        state.options.splice(index, 1)
      }else if(param.update){
        Object.assign(state.options[index], param.update)
      }else{
        console.warn(`appbar.updateOption do nothing`, param)
      }
    },
    update(state, status){
      let keys = ['dense', 'color', 'dark', 'prominent', 'title', 'fixed']
      for(let key of keys){
        if(status[key]){
          state[key] = status[key]
        }
      }
    }
  }
}
export default appbar
